// translate old rules model to new model

export default function translateRules(rules) {
  let rule;
  for (var key in rules) {
    rule = rules[key];
    // we identify the old model by the presence of rule.delay
    if (rule.delay) {
      rule.displayDelay = rule.delay;
      if (rule.proactive) {
        rule.openDelay = 0;
      }
    } else if (!rule.displayDelay && !rule.delay) {
      rule.displayDelay = 0;
    }

    delete rule.delay;
    delete rule.proactive;
  }

  return rules;
}
``;
